import { isNil } from 'lodash';

/**
 * Coerces any value to an array and additionally removes any nil values.
 */
export const toArray = <T = any>(value: T | T[]): T[] => {
  if (isNil(value)) {
    return [];
  }

  return (Array.isArray(value) ? value : [value]).filter((v) => !isNil(v));
};
